export default {
  overview: '概览',
  today_overview: '今日概览',
  balance: '余额',
  in_transit: '在途',
  abd_balance: 'ADB金额',
  total_transaction: '总交易',
  transaction_count: '交易笔数',
  transaction_amount: '交易金额',
  transaction_fee: '交易费用',
  payin: '收款交易',
  payout: '付款交易',
  number: '笔数',
  amount: '金额',
  payin_number: '收款笔数',
  payout_number: '付款笔数',
  payin_amount: '收款金额',
  payout_amount: '付款金额',
  transaction_trends: '交易趋势',
  all: '全部',
  fee: '服务费',
  today: '今天',
  week: '过去7天',
  month: '过去30天',
  commission: '佣金',
  my_assets: '我的资产',
  account_balance: '账户余额',
  balance_exchange_rate_tip: '根据实时汇率计算得出，实际余额以提现页面为准',
  withdraw_now: '立即提现',
  collapse: '收起',
  expand_more: '展开更多',
  reference_exchange_rate: '实时参考汇率',
  updated_at: '更新于',
  exchange_rate_disclaimer: '本汇率数据仅供参考，请以实际购买时的交易汇率为准。',
  currency_assets: '币种资产',
  available: '可用',
  frozen: '冻结'
}
